import store from '@/store/index'
import { groupBy as _groupBy } from 'lodash-es'
import {
  getDicListNew,
  fetchDrugUsageList,
  fetchDrugFrequenceList
} from '@/views/funcPuzzle/utils/index.js'

// 获取字典表
export const setTargetKeyValue = async hospitalID => {
  if (store.state.targetKeyValue) {
    return false
  }
  const dicRes = await getDicListNew({
    pageSize: 99999,
    hospitalID
  })

  const usageRes = await fetchDrugUsageList({
    hospitalID
  })
  const frequenceRes = await fetchDrugFrequenceList({
    hospitalID
  })

  const dicList = _groupBy(dicRes.dicList, 'tableName')

  const drugUsageAll = (usageRes && usageRes.data) || []
  const drugUsage = _groupBy(drugUsageAll, 'tableName')
  for (const key of Object.keys(drugUsage)) {
    dicList[key] = drugUsage[key]
  }

  // const FrequenceListAll = frequenceRes?.data ?? []
  const FrequenceListAll = (frequenceRes && frequenceRes.data) || []
  const drugFrequence = _groupBy(FrequenceListAll, 'tableName')
  for (const key of Object.keys(drugFrequence)) {
    dicList[key] = drugFrequence[key]
  }
  store.commit('SET_TARGET_KEY_VALUE', dicList)
}
